import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation editCardLimit(
      $cardId: ID!
      $limitId: ID!
      $limitPeriod: LimitPeriodInput!
      $limitValue: Float!
    ) {
      editCardLimit(
        cardId: $cardId
        limitId: $limitId
        limitPeriod: $limitPeriod
        limitValue: $limitValue
      ) {
        success
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.cardId,
    options: ({ cardId, limitId, limitPeriod, limitValue }) => ({
      variables: {
        cardId,
        limitId,
        limitPeriod,
        limitValue,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    limitId: PropTypes.string.isRequired,
    limitPeriod: PropTypes.oneOf(["DAILY", "MONTHLY", "CUSTOM"]).isRequired,
    limitValue: PropTypes.number.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/cardLimit/editCardLimit.js